{
  "topMenu": {
    "dihTitle": "数据智能中心",
    "dihSubTitle": "安全地从数据中提取价值",
    "logout": "登出",
    "dihPortal": "DIH 门户",
    "cofinityDataspace": "数据空间门户"
  },
  "userLogoutAlert": {
    "title": "您确定要登出吗？",
    "back": "返回",
    "logout": "登出"
  },
  "languages": {
    "en": "英语",
    "de": "德语（德语）",
    "es": "西班牙语 (Español)",
    "fr": "法语（法语）",
    "zh": "中文（中文/简体）",
    "ja": "日语（日本语）"
  },
  "sideMenu": {
    "home": "首页",
    "collapse": "收起侧边栏",
    "help": "帮助",
    "prepare": "模型管理",
    "model": "数据模型",
    "mapping": "数据映射",
    "converter": "数据转换器",
    "provide": "提供",
    "publishData": "发布数据",
    "assets": "资产",
    "policyPublicationTemplate": "政策发布模板",
    "uploadHistory": "资产上传历史",
    "consume": "消费",
    "searchDataOffers": "搜索数据优惠",
    "negotiatedDataOffers": "已协商的数据优惠",
    "downloadHistory": "资产下载历史",
    "govern": "治理",
    "myPolicies": "我的政策",
    "createPolicies": "创建政策",
    "policyTemplate": "政策模板",
    "manageAndConfig": "配置",
    "connections": "管理连接器",
    "jobs": "处理日志",
    "monitoring": "监控",
    "licences": "许可证",
    "providedAgreements": "提供的合同协议",
    "incomingAgreements": "传入的数据优惠",
    "consumedAgreements": "消费的合同协议",
    "consumeAutomation": "消费政策自动化",
    "networkAnalytics": "网络分析",
    "otherLogs": "其他日志",
    "digitalTwin": "数字孪生浏览器",
    "messagesBrowserInbound": "入站消息",
    "messagesBrowserOutbound": "出站消息",
    "applications": "应用程序",
    "pcfExchange": "PCF 交换",
    "pcfRequests": "PCF 数据请求",
    "pcfExchangeHistory": "PCF 数据交换历史",
    "publicationTemplates": "发布模板",
    "certificateManagement": "证书管理",
    "certificates": "证书",
    "connectors": "我的连接器",
    "contractDefinitions": "我的合同定义"
  },
  "versionModal": {
    "title": "一般信息",
    "error": "无法获取版本详细信息",
    "table": {
      "title": "组件详细信息",
      "componentName": "组件名称",
      "imageVersion": "镜像版本",
      "chartVersion": "图表版本"
    }
  },
  "dropdown": {
    "selectAll": "全选",
    "noOption": "没有可用选项",
    "noSuchOption": "没有此选项...",
    "selectConnection": "选择连接"
  },
  "certificateManagement": {
    "title": "业务合作伙伴证书管理",
    "description": "欢迎使用 Catena-X 中便捷的端到端业务合作伙伴证书交换解决方案。",
    "howTo": {
      "description": "探索其他 Catena-X 成员公司的数据产品目录。您可以搜索、选择并订阅证书产品，也可以通过公司名称进行搜索。",
      "doc": "想了解业务合作伙伴证书管理是如何运作的吗？"
    },
    "landingTiles": {
      "tile_1": {
        "title": "发布证书",
        "description": "在 Catena-X 网络中创建和共享您的站点证书。"
      },
      "tile_2": {
        "title": "发现并使用证书",
        "description": "轻松搜索和下载网站及商业证书。"
      },
      "tile_3": {
        "title": "证书发布历史",
        "description": "您提供的所有证书概览"
      },
      "tile_4": {
        "title": "已使用证书历史",
        "description": "您已使用的所有证书概览"
      },
      "tile_5": {
        "title": "传入的证书请求",
        "description": "传入的共享证书请求概览"
      },
      "tile_6": {
        "title": "传出的证书状态",
        "description": "用于共享证书的操作概览"
      },
      "tile_7": {
        "title": "请求证书",
        "description": "轻松搜索和下载网站及商业证书。"
      }
    },
    "recentCertificateRequests": "最近的传入证书数据请求",
    "learnMore": "了解更多关于证书管理的信息",
    "pushCertificate": "推送证书",
    "pushDescription": "现有证书将共享给下方所选的合作伙伴。请注意，将应用与原始要约中相同的政策。如果您希望更改政策，请创建一个新的数据要约。",
    "requestCertificates": "请求新证书",
    "pushSuccess": "证书推送过程已启动！作业 ID 为 {id}",
    "receiverBpn": "接收器 BPN",
    "providerBpn": "供应商 BPN",
    "locationBpns": "站点 BPNA/BPNS",
    "certificateType": "证书类型",
    "requestSuccess": "已成功提交证书请求",
    "pushResult": "{total}个{status}请求中有{successful}个成功",
    "receiveConfirmTitle": "确认接收证书",
    "receiveConfirmDesc": "点击“是”即表示您确认已收到合作伙伴共享的证书。提供方将收到您的确认。接下来，您可以接受或拒绝该证书。",
    "acceptedConfirmTitle": "接受证书",
    "acceptedConfirmDesc": "点击“是”即表示您接受该证书符合预期。您可以点击查看图标将证书下载为 PDF。",
    "rejectedConfirmTitle": "拒绝证书",
    "rejectedConfirmDesc": "点击“是”即表示您拒绝接收到的证书。提供方将收到拒绝通知。他们可以重新分享，或者您可以再次请求新证书。",
    "processStarted": "'{type}' 流程已开始！任务编号是 {id}",
    "certificateDetails": "证书详情",
    "availableCertificate": "可用证书位置",
    "updateSuccess": "证书成功更新了！",
    "updateFailure": "证书更新失败！"
  },
  "common": {
    "start": "开始",
    "firstName": "名字",
    "lastName": "姓氏",
    "email": "电子邮件地址",
    "phoneNumber": "电话号码",
    "contactPerson": "联系人",
    "welcome": "欢迎",
    "street": "街道",
    "city": "城市",
    "country": "国家",
    "postCode": "邮政编码",
    "number": "号码",
    "next": "下一步",
    "prev": "返回",
    "alreadyAccount": "已有账户？",
    "login": "登录",
    "loginNow": "立即登录",
    "register": "注册",
    "home": "首页",
    "submit": "提交",
    "attention": "注意",
    "desc": "描述",
    "website": "网站",
    "contact": "联系",
    "details": "详情",
    "plan": "计划",
    "table": "表格",
    "grid": "网格",
    "listView": "列表视图",
    "gridView": "网格视图",
    "firstPage": "到第一页",
    "previousPage": "到上一页",
    "nextPage": "到下一页",
    "lastPage": "到最后一页",
    "paginationUnknownButton": "未知的分页按钮类型",
    "download": "下载",
    "delete": "删除",
    "edit": "编辑",
    "information": "信息",
    "organization": "组织",
    "cancel": "取消",
    "save": "保存",
    "upload": "上传",
    "link": "链接",
    "view": "查看",
    "search": "搜索",
    "searchTerm": "搜索",
    "selectOption": "选择一个选项",
    "sortBy": "排序方式",
    "dataspace": "数据空间",
    "select": "选择",
    "date": "日期",
    "title": "标题",
    "back": "返回",
    "startTyping": "开始输入",
    "useCases": "用例",
    "done": "完成",
    "enterValue": "输入值",
    "selectValue": "选择值",
    "selectDate": "选择日期",
    "refresh": "刷新",
    "searchByName": "按名称搜索",
    "close": "关闭",
    "copyToClipboard": "已复制到剪贴板！",
    "enterKeyName": "输入键名",
    "fileDownloadSuccess": "文件下载成功",
    "fileDownloadError": "文件下载失败",
    "certificate": "证书",
    "manageConnections": "管理连接",
    "confirm": "确认",
    "yes": "是",
    "no": "否",
    "connectionDetails": "{type}连接详细信息",
    "hide": "隐藏",
    "unpublish": "未出版",
    "clear": "清除",
    "viewAll": "查看全部",
    "apply": "申请",
    "from": "从",
    "to": "到",
    "isRequired": "是必须的",
    "confirmationRequired": "请勾选此框进行确认",
    "send": "发送",
    "update": "更新"
  },
  "genericError": "哦，出了点问题！请重试。",
  "validation": {
    "fieldRequired": "{field} 是必填项。",
    "fieldNumeric": "字段 {field} 只能包含数字。",
    "fieldAlpha": "字段 {field} 只能包含字母、_ 和 -。",
    "fieldAlphanumeric": "字段 {field} 只能包含字母、数字、_ 和 -。",
    "fieldNumericDash": "字段 {field} 只能包含数字和 -。",
    "fieldHouseNumber": "字段 {field} 只能包含数字、字母以及字符 - 和 /。",
    "fieldPhoneNumber": "字段 {field} 只能包含数字和 -，必须以 + 或 00 开头。",
    "fieldAlphaDash": "字段 {field} 只能包含字母和 -。",
    "exceptHTMLTagBrackets": "字段 {field} 不得包含以下字符：^<>",
    "isMaxLength": "超出最大长度 10 个字符。",
    "emailFormat": "电子邮件地址格式错误",
    "fileSizeError": "文件大小超过 {size} MB。",
    "csvFileSizeError": "文件过大。您可以上传最大 {size} MB 的文件。",
    "csvFileExtensionError": "仅允许上传 csv 扩展名的文件。",
    "csvFileIsEmptyError": "文件为空。您需要上传至少 {size} KB 的文件。",
    "csvFileFormatError": "文件格式不符合预期。请使用提供的模板重试。",
    "uploadFails": "上传失败",
    "fileExtensionError": "文件扩展名不合适",
    "fileIsMalwareInfectedError": "此文件似乎包含恶意软件。出于安全原因，无法上传此文件。请再次检查您的文件。",
    "customValidation": "{field} 格式错误。",
    "selectCountryFirst": "请先选择国家名称",
    "validationPostCodeCaseDE": "字段格式错误。必须包含 5 位数字，例如 53113",
    "validationAlphanumericCase": "字段只能包含字母、数字、破折号和下划线。值必须以字母或数字开头。",
    "validationNumericDashCase": "字段只能包含数字和 -。",
    "url": "请输入有效的 URL",
    "required": "此字段为必填项",
    "password": {
      "passwordStrength": "密码强度",
      "weak": "弱",
      "average": "中等",
      "strong": "强",
      "passwordValidationMoreChar": "{count} 个或更多字符",
      "passwordUpperAndLowerChar": "大小写字母",
      "passwordAtLeastNumber": "至少一个数字",
      "passwordAtLeastSpecialChar": "至少一个特殊字符（除了 <>&\"`[]）",
      "passwordDiffFromPrev": "与之前的密码不同"
    }
  },
  "footer": {
    "tagLine": "让我们助力更高的性能",
    "imprint": "法律声明",
    "imprintShort": "声明",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "联系我们",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "条款与条件",
    "privacy": "隐私政策",
    "privacyShort": "隐私",
    "telekom": "T-Systems International GmbH。保留所有权利。",
    "telekomShort": "T-Systems 国际有限公司",
    "note": "电信数据智能中心 - 仅限商业客户",
    "brandedNote": "由电信数据智能中心提供支持",
    "help": "帮助",
    "cookieSettings": "Cookie 设置",
    "cookieSettingsShort": "曲奇饼",
    "life": "生活因分享而精彩"
  },
  "cookieSettings": {
    "collapsedTitle": "隐私设置",
    "collapsedText": "本网站使用 cookies 和类似技术。这些是存储和读取您计算机上的小文本文件。通过点击“{0}”，您同意处理、跨网站和合作伙伴创建个人用户档案，以及将您的数据传输给第三方，其中一些第三方在欧盟以外的国家（GDPR 第 49 条）处理您的数据。详情请见{1}的第 2 节。数据用于分析、重新定位以及在电信网站和第三方网站上播放个性化内容和广告。更多信息，包括第三方提供商的数据处理信息和撤销的可能性，请见设置和我们的隐私信息。在此您可以{2}仅使用必要的工具。",
    "extendedTitle": "隐私设置",
    "extendedText": "为了为您提供最佳的网站体验，我们使用 cookies。这些包括用于网站操作和优化的 cookies，以及基于您的在线使用行为的服务（如文本或视频聊天）和广告。这使我们能够例如检测您是否从同一设备重复访问我们的页面。我们希望您可以选择允许哪些 cookies：",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "隐私信息",
    "policyLinkText": "隐私信息",
    "rejectLinkText": "继续",
    "acceptButton": "接受所有",
    "saveButton": "保存设置",
    "settingsButton": "更改设置",
    "showMore": "显示更多",
    "showLess": "显示更少",
    "categoryTitleEssential": "必要 cookies",
    "categoryTitleAnalytics": "分析 cookies",
    "categoryTitleMarketing": "营销 cookies",
    "categoryTitleThirdParty": "第三方服务（独立第三方提供商）",
    "categoryTextEssential": "这些 cookies 是您浏览网站和使用关键功能所必需的。它们支持基本功能，如在线商店的订单处理和访问网页的安全区域。它们还用于匿名分析用户模式，我们使用这些数据不断开发和改进我们的网页。",
    "categoryTextAnalytics": "这些 cookies 帮助我们更好地理解用户行为。分析 cookies 允许原始提供商或第三方提供商将使用和识别数据编译成匿名使用档案。我们使用分析 cookies 例如确定网页或服务的单个访问者数量，收集产品性能的统计数据，并基于匿名和伪匿名信息分析访问者的使用模式和交互。这些信息无法追溯到个人。",
    "categoryTextMarketing": "这些 cookies 和类似技术用于显示个性化的、因此相关的营销内容。营销 cookies 用于显示有趣的广告内容并衡量我们活动的有效性。这不仅在电信网站上进行，还在其他广告合作伙伴网站（第三方提供商）上进行。这被称为重新定位，用于创建伪匿名内容或广告档案，在其他网站上放置相关广告，并推导目标群体的见解，这些群体查看了广告和内容。这些信息无法追溯到个人。营销和重新定位工具帮助我们为您提供可能相关的广告内容。如果禁用营销 cookies，您看到的广告数量不会减少，但可能与您的相关性较低。",
    "categoryTextThirdParty": "电信的网站包括指向第三方服务提供商的链接，这些提供商在自己的责任下提供服务。当您访问电信的网页时，cookies 或类似技术会记录数据并将其发送给第三方，部分用于电信自身的目的。第三方自身目的的处理范围、目的和法律依据可在第三方的隐私信息中找到。有关独立第三方提供商的信息可在隐私信息中找到。"
  },
  "messages": {
    "noDataAvailable": "无可用数据",
    "noMatchFound": "未找到匹配项",
    "maximumFileSize": "最大文件大小",
    "suitableFileFormats": "适合的文件格式",
    "loading": "加载中...",
    "dragDropText": "或将文件拖放到此处",
    "noConnectors": "未找到连接器！",
    "comingSoon": "即将推出"
  },
  "pageNotFound": {
    "title": "哎呀！您寻找的页面尚不存在。",
    "subtitle": "与此同时，请查看我们的其他资源，可能会对您有所帮助！"
  },
  "helpResources": {
    "needHelp": "需要帮助选择合适的计划、获取更多信息或解答技术问题？",
    "developerDoc": "集成者文档",
    "developerDocDesc": "获取 API 文档以开始使用",
    "example": "示例",
    "tutorials": "教程",
    "exampleDescription": "查找与您的行业相关的用例和演示",
    "FAQ": "常见问题",
    "FAQDescription": "查找从计费到隐私的更多常见答案",
    "browse": "浏览",
    "demos": "演示",
    "demosDescription": "查找与您的行业相关的用例和演示",
    "glossary": "术语表",
    "glossaryDescription": "查找与数据智能中心、IDSA、Catena-X、Gaia-X 等相关的术语和定义。",
    "contactUs": "此功能在您当前的订阅中不受支持。请联系我们以升级。"
  },
  "feedbackCard": {
    "title": "需要更多帮助？",
    "contactUs": "联系我们"
  },
  "error": {
    "pageNotFound": "页面未找到 (404)",
    "somethingWrong": "出了点问题！",
    "propertyNotFound": "属性未找到",
    "uniquePropertyName": "属性名称必须唯一",
    "dctTypeNotFound": "dct:type 未找到"
  },
  "helpWidget": {
    "askSupport": "询问支持",
    "chatboxTitle": "帮助聊天",
    "chatboxSubtitle": "电信数据智能中心支持",
    "defaultMessage": {
      "body": "您好，欢迎体验电信数据智能中心支持频道。请在下方选择一个选项。"
    },
    "whatCanWeHelpWith": "今天我们能帮您什么？",
    "suggestedAnswers": {
      "knowledgeBase": "知识库、文档和常见问题",
      "contactSupport": "联系支持",
      "contactSales": "联系销售"
    }
  },
  "pcfExchange": {
    "title": "PCF 交换",
    "description": "欢迎体验 Catena-X 中简单易用的端到端产品碳足迹（PCF）交换解决方案。",
    "recentRequests": "最近的 PCF 数据请求",
    "viewAllRequests": "查看所有请求",
    "requestPcf": "请求 PCF",
    "termCheck": "通过提交请求，我理解合同将根据数据提供者设定的政策进行协商。",
    "pcfSuccess": "PCF 请求成功！",
    "landing": {
      "pcfTitle": "创建 PCF 优惠",
      "pcfDesc": "在 Catena-X 网络中创建并与参与者分享 PCF 数据。",
      "discoverTitle": "发现和请求 PCF 数据",
      "discoverDesc": "在 Catena-X 网络中轻松搜索 PCF 数据或通过几个步骤从您的合作伙伴请求 PCF 数据。",
      "pcfReqTitle": "PCF 数据请求",
      "pcfReqDesc": "在 Catena-X 网络中高效管理来自您合作伙伴的 PCF 数据请求。",
      "pcfCalcTitle": "PCF 计算器",
      "pcfCalcDesc": "计算 PCF 值并无缝连接到您的应用程序或 PCF 数据交换场景。",
      "pcfHistoryTitle": "PCF 数据交换历史",
      "pcfHistoryDesc": "在 Catena-X 网络和您的合作伙伴中获得 PCF 数据交换历史的透明度。",
      "documentation": "了解 PCF 数据交换",
      "howTo": {
        "description": "在 Catena-X 中分享、发现和管理产品碳足迹（PCF）数据优惠。",
        "doc": "想了解更多关于连接和集成的信息？文档链接："
      }
    },
    "requests": {
      "pcfRequests": "PCF 数据请求",
      "reqDesc": "使用此区域管理来自合作伙伴的 PCF 数据请求。",
      "productId": "产品 ID*",
      "bpn": "业务PN*",
      "message": "消息",
      "howTo": {
        "title": "想了解更多关于 PCF 数据请求管理工作的信息？",
        "description": "使用此部分批准或拒绝来自您合作伙伴的 PCF 数据请求。此外，查看 PCF 数据交换的状态并在您的 PCF 数据链中获得完全透明度。",
        "doc": "想了解更多关于数据优惠协商和消费如何运作的信息？"
      }
    },
    "responses": {
      "howTo": {
        "description": "发现其他 Catena-X 成员公司的数据优惠目录。您可以搜索、选择和订阅数据优惠。您可以使用公司名称或制造商零件 ID 或两者的组合搜索数据优惠。"
      }
    },
    "view": {
      "title": "查看 PCF 详情"
    }
  },
  "publicationTemplates": {
    "title": "我的发布模板",
    "deletedTemplates": "我的已删除模板",
    "showDeletedTemplates": "显示已删除模板",
    "hideDeletedTemplates": "显示活跃模板",
    "newTemplate": "新模板",
    "create": {
      "title": "创建发布模板",
      "edit": "编辑发布模板",
      "templateName": "模板名称",
      "templateType": "{type} 模板",
      "create": "创建",
      "update": "更新",
      "name": "名称",
      "createdAt": "创建时间",
      "modifiedAt": "修改时间",
      "country": "国家",
      "accessPolicyId": "访问政策",
      "usagePolicyId": "使用政策",
      "id": "ID",
      "createdBy": "创建者",
      "modifiedBy": "修改者",
      "isEnabled": "是否启用",
      "targetCompany": "目标公司",
      "targetConnectors": "目标连接器",
      "selectCountry": "选择国家",
      "templateDetails": "发布模板详情",
      "assetsCriteria": "资产选择标准",
      "connectorDetails": "连接器详情"
    },
    "delete": {
      "title": "删除发布模板",
      "description": "您确定要删除此模板吗？",
      "button": "删除"
    }
  },
  "contracts": {
    "title": "合同协议详情",
    "provider": {
      "description": "这是您组织与其他数据空间参与者的合同协议概览。",
      "howItWorks": {
        "description": "在这里您可以找到跨各种数据空间的订阅或协商数据协议。您可以按特定连接器过滤结果，或使用合同协议 ID 或资产 ID 进行搜索。您还可以根据需求对列表进行排序。此外，您可以选择数据优惠并在本地导出。",
        "subtitle": "想了解更多关于数据优惠协商和消费如何运作的信息？"
      },
      "details": {
        "title": "提供的合同协议详情",
        "description": "描述",
        "content": "内容",
        "agreementDetails": "协议详情",
        "assetDetails": "资产详情",
        "usagePolicy": "使用政策"
      }
    },
    "consumer": {
      "description": "这是您组织对其他数据空间参与者数据优惠的合同协议概览。",
      "downloadData": "下载数据",
      "downloadAgreement": "下载协议",
      "reinitiate": "启动传输和下载数据",
      "error": {
        "heading": "抱歉！您似乎已经协商过此合同。",
        "body": "您无法重新协商已协商的合同。您可以在下方找到合同详情，还可以下载此协议并订阅数据。"
      },
      "details": {
        "title": "消费的合同协议详情"
      },
      "howItWorks": {
        "description": "在这里您可以找到跨各种数据空间的订阅或协商数据协议。您可以按特定连接器过滤结果，或使用合同协议 ID 或资产 ID 进行搜索。您还可以根据需求对列表进行排序。此外，您可以选择数据优惠并在本地导出。",
        "subtitle": "想了解更多关于数据优惠协商和消费如何运作的信息？"
      }
    }
  },
  "provider": {
    "provider": "提供者",
    "assets": {
      "title": "我的资产",
      "offeredBy": "提供者：",
      "offers": "优惠",
      "created": "创建时间",
      "modifiedAt": "修改时间",
      "noResultsFound": "未找到资产",
      "success": "资产创建成功",
      "updateSuccess": "资产更新成功",
      "buttons": {
        "createOffer": "创建优惠",
        "details": "查看详情",
        "delete": "删除资产",
        "create": "创建资产",
        "close": "关闭",
        "edit": "编辑资产",
        "update": "更新资产",
        "showDeleted": "显示已删除资产",
        "hideDeleted": "隐藏已删除资产",
        "restore": "恢复资产",
        "save": "保存",
        "add": "添加键值对",
        "addJson": "添加 JSON 对象",
        "editJson": "编辑 JSON 对象",
        "saveJson": "保存 JSON",
        "advanceAddition": "高级添加",
        "unpublish": "不公开资产",
        "showAssets": "显示资产"
      },
      "detailsDialog": {
        "title": "资产详情"
      },
      "createDialog": {
        "title": {
          "general": "创建新资产",
          "edit": "编辑资产",
          "addProperties": "添加属性",
          "advance": "高级属性添加"
        },
        "publicProps": "公共属性",
        "privateProps": "私有属性",
        "dataAddress": "数据地址",
        "dataSources": "数据源",
        "dataDestination": "数据目的地",
        "json": {
          "fields": "JSON 字段",
          "editor": "自定义属性编辑器",
          "formatted": "自定义属性查看器",
          "error": "无效 JSON："
        },
        "connectionTypeLabel": {
          "http": "请输入 URL",
          "s3": "请输入对象名称",
          "azure": "请输入 Blob 名称",
          "sftp": "请输入文件名"
        },
        "fields": {
          "name": "名称",
          "namePlaceholder": "输入优惠名称",
          "id": "ID",
          "description": "描述",
          "contenttype": "内容类型",
          "contenttypePlaceholder": "输入内容类型",
          "contentType": "内容类型",
          "contentTypePlaceholder": "输入内容类型",
          "version": "版本",
          "keywords": "关键字",
          "language": "语言",
          "languagePlaceholder": "选择语言",
          "semanticId": "语义 ID",
          "semanticIdPlaceholder": "请输入语义 ID",
          "dct:type": "DCT：类型",
          "dct:typePlaceholder": "选择 dct 类型",
          "keywordsPlaceholder": "添加关键字",
          "descriptionPlaceholder": "编写优惠描述",
          "versionPlaceholder": "版本号",
          "dataType": "数据地址类型",
          "dataTypePlaceholder": "选择数据地址类型",
          "dataAddressUrl": "资产 URL",
          "dataAddressUrlPlaceholder": "输入资产 URL",
          "targetCompany": "目标公司",
          "targetCompanyPlaceholder": "输入目标公司",
          "country": "国家",
          "countryPlaceholder": "输入国家",
          "key": "键",
          "keyPlaceholder": "输入键",
          "value": "值",
          "valuePlaceholder": "输入值",
          "assetType": "资产类型",
          "assetTypePlaceholder": "输入资产类型"
        },
        "validation": {
          "name": "请输入名称",
          "assetType": "请选择资产类型",
          "contentType": "请输入有效的内容类型",
          "dataType": "请选择有效的数据类型",
          "targetCompany": "请输入有效的目标公司",
          "country": "请输入有效的国家"
        }
      },
      "tags": {
        "restricted": "访问受限",
        "unrestricted": "无限制"
      },
      "search": {
        "title": "搜索过滤器",
        "helperText": "搜索资产名称、创建日期或类型",
        "filters": {
          "byName": "资产名称",
          "byType": "资产类型",
          "byDate": "修改日期"
        }
      },
      "delete": {
        "title": "删除资产",
        "description": "您确定要删除此资产吗？"
      },
      "unpublish": {
        "title": "不公开资产",
        "description": "您确定要未出版这项资产吗？"
      }
    },
    "fileUploadTerms": "我理解并确认我已正确填写所有必需的信息，如果信息不正确并拒绝报价，T-Systems 概不负责。",
    "fileUploadInfo": "T-Systems 不会检查此处填写的元数据信息的有效性。请确保您填写的信息正确完整。",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "单程输入",
    "bulkEntries": "批量条目"
  },
  "home": {
    "title": "连接与集成"
  },
  "gettingStarted": {
    "title": "需要帮助开始吗？",
    "openWizard": "打开向导",
    "yourDataOffering": "您的数据优惠",
    "yourAssets": "资产",
    "yourPolicies": "我的政策",
    "preconfiguredCatalogue": "预配置目录",
    "contractAgreements": "合同协议",
    "incomingAgreements": "传入协议",
    "outgoingAgreements": "传出协议",
    "connectors": "您的连接器",
    "providedAgreements": "提供的合同协议",
    "consumedAgreements": "消费的合同协议"
  },
  "yourConnection": {
    "title": "您的连接器",
    "viewAllConnection": "查看所有连接器",
    "help": "帮助",
    "documentation": "了解您的连接与集成",
    "gettingStarted": "入门指南",
    "noUseCases": "没有可用用例"
  },
  "wizardSelectionPopup": {
    "whatToLike": "您今天想做什么？",
    "prepare": "准备",
    "govern": "治理",
    "provide": "提供",
    "consume": "消费",
    "howToProvide": "您今天想如何提供数据？",
    "manual": "手动",
    "automated": "通过 API 自动化",
    "selectUseCases": "选择您的用例",
    "selectSingleUseCase": "选择您的用例",
    "selectDigitalTwin": "选择您的数字孪生类型",
    "back": "返回",
    "next": "下一步",
    "publish": "我理解数据空间的框架要求，并同意代表我的组织在数据空间中发布数据优惠。"
  },
  "createOffer": {
    "title": {
      "standard": "创建数据优惠",
      "pcf": "创建 PCF 数据优惠",
      "certificate": "创建证书选件"
    },
    "publish": "发布",
    "legalConfirmation": "我理解数据空间的框架要求，并同意代表我的组织在数据空间中发布数据优惠。",
    "wizard": {
      "provisionAsset": "提供资产",
      "dataUpload": "数据选择",
      "attachPolicy": "附加政策",
      "publishDataOffer": "发布数据优惠"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "您想为哪个子模型创建数据优惠？",
      "selectSubmodel": "选择子模型",
      "selectUsecase": "选择用例",
      "selectDigitalTwinType": "选择数字孪生类型",
      "whichTypeToSelect": "我应该选择哪种类型？",
      "generalInformation": "常规信息",
      "name": "名称",
      "id": "ID",
      "description": "描述",
      "contentType": "内容类型",
      "version": "版本",
      "keywords": "关键字",
      "language": "语言",
      "location": {
        "title": "位置和寻址",
        "text": "请输入您的资产详情"
      },
      "username": "用户名",
      "password": "密码",
      "assetUrl": "资产 URL",
      "assetUrlPlaceHolder": "请输入您的资产 URL",
      "clientId": "客户端 ID",
      "clientSecret": "客户端密钥",
      "tokenUrl": "令牌 URL",
      "tokenUrlPlaceHolder": "请输入您的令牌 URL",
      "provideAssets": "提供资产",
      "selectConnectorLabel": "选择您想与之共享数据的连接器",
      "selectConnectorPlaceholder": "选择连接器",
      "selectRestApiType": "选择 REST-API 类型",
      "selectedAuthMethod": "认证方法"
    },
    "dataUpload": {
      "selectedDataModel": "选择您的数据",
      "csvUpload": {
        "title": "CSV 文件",
        "description": "将文件拖放到此处",
        "uploadFile": "选择文件",
        "uploadFileDescription": "准备并上传您想要交换的文件。您可以下载示例文件以帮助您开始使用 Catena-X 所需的格式。",
        "uploadFileDescriptionNote1": "从下面的链接下载模板文件",
        "uploadFileDescriptionNote2": "在提供的文件中填写您的合作伙伴详情",
        "uploadFileDescriptionNote3": "在提供的区域上传文件",
        "partnerValidationNote": "如果您想了解更多关于合作伙伴验证的信息，请",
        "clickHere": "点击这里",
        "downloadTemplate": "下载模板",
        "downloadSampleCsv": "下载示例 CSV",
        "supportedFileTypes": "支持的文件类型："
      },
      "jsonUpload": {
        "title": "JSON",
        "description": "编写自定义json代码"
      },
      "tableUpload": {
        "title": "表格",
        "description": "提供自定义表格条目",
        "add": "添加"
      },
      "fileUpload": {
        "title": "文件上传",
        "description": "CSV、JSON"
      },
      "objectStorage": {
        "title": "对象存储",
        "description": "AWS、Azure、OTC 或 GCP"
      },
      "sftp": {
        "title": "SFTP 服务器",
        "description": "通过 SFTP 传输"
      },
      "apiUpload": {
        "title": "休息API",
        "description": "通过 API 传输",
        "authAndIdentiTitle": "认证和身份验证",
        "authAndIdentiDesc": "请输入您目标系统的认证详情",
        "selectApiType": "选择 REST-API 类型",
        "locationAndAddrTitle": "位置和寻址",
        "locationAndAddrDesc": "请输入您的资产详情",
        "assetUrl": "资产 URL",
        "username": "用户名",
        "password": "密码",
        "clientId": "客户端 ID",
        "clientSecret": "客户端密钥"
      }
    },
    "fileUpload": {
      "title": "将您的文件拖放到此处",
      "btnText": "选择文件"
    },
    "attachPolicy": {
      "title": "为此数据优惠附加政策",
      "createPolicy": "创建新政策",
      "bpnFieldTitle": "您想与谁交换数据？",
      "howItWork": {
        "title": "它是如何工作的？",
        "description": "我们根据 Catena-X 用例框架协议预配置政策。仅允许提供的业务合作伙伴编号访问您的数据。",
        "knowMore": "想了解更多关于政策的信息？",
        "documentation": "文档"
      },
      "accessPolicyTableText": "为此数据优惠附加访问政策",
      "usagePolicyTableText": "为此数据优惠附加使用政策",
      "heading": {
        "title": "附加现有政策或创建新政策",
        "description": "请从下表附加访问和使用政策以完成数据优惠发布。您还可以使用政策名称搜索政策，或者在没有所需政策时创建新政策。"
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "数据优惠详情",
      "generalInformation": "常规信息",
      "attribute": "属性",
      "value": "值",
      "knowMore": "了解更多关于您的数据优惠",
      "attachedDataAssets": "附加项目",
      "attachedPolicies": "附加政策",
      "allowPolicyPublish": "我允许政策发布",
      "publish": "发布",
      "verifiedLegalEntity": "由以下验证的法人实体",
      "dataOfferCreatedBy": "数据优惠创建者：",
      "contactOrgAdmin": "联系组织管理员",
      "help": "帮助",
      "attachedDataAsset": "附加数据资产",
      "attachedAccessPolicy": "附加访问政策",
      "attachedUsagePolicy": "附加使用政策",
      "publishedConnectors": "此优惠将发布到的连接器",
      "knowMoreConnector": "了解更多关于您的连接器",
      "knowMorePolicies": "了解更多关于您的政策",
      "knowMoreDataAssets": "了解更多关于您的数据资产",
      "knowMoreDataOffers": "了解更多关于您的数据优惠",
      "publishCheckboxLabel": "我代表我的组织同意在数据空间中发布数据优惠和资产。我确认使用相关政策来管理数据空间及其相关政策，并且我将遵循数据空间的框架对已发布的优惠和资产进行任何操作。"
    },
    "result": {
      "success": {
        "title": "请求成功。",
        "description": "资产发布流程已开始！任务 ID 为 {id}"
      }
    },
    "success": {
      "title": "您的数据优惠现已发布",
      "description": "您的数据优惠现已发布，点击以下内容查看后续步骤",
      "createOffer": "创建另一个数据优惠",
      "createOfferButton": "创建",
      "goToHome": "返回首页",
      "goToHomeButton": "返回首页",
      "uploadHistory": "检查您的上传历史"
    }
  },
  "policy": {
    "newPolicy": "新政策",
    "showDeletedPolicies": "显示已删除政策",
    "myDeletedPolicies": "我的已删除政策",
    "hideDeletedPolicies": "显示活跃政策",
    "restoreAsset": "恢复",
    "publishDeletion": "发布删除",
    "create": {
      "title": "创建新政策",
      "edit": "编辑政策",
      "policyName": "政策名称",
      "policyType": "{type} 政策",
      "accessPolicy": "访问政策",
      "usagePolicy": "使用政策",
      "create": "创建并保存",
      "update": "更新"
    },
    "delete": {
      "title": "删除政策",
      "description": "您确定要删除此政策吗？",
      "button": "删除"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "业务合作伙伴编号",
        "description": "业务合作伙伴数量限制可用于定义允许哪些具体业务合作伙伴（基于 BPNL）查看或协商相应的数据报价。"
      },
      "BusinessPartnerGroup": {
        "title": "业务合作伙伴组",
        "description": "业务合作伙伴组限制可用于定义允许哪些具体业务合作伙伴（基于 BPNL）查看或协商相应的数据报价。"
      },
      "Membership": {
        "title": "会员资格",
        "description": "会员凭证可用于确保只有 CX 会员才能查看或协商相应的数据优惠。"
      },
      "ContractReference": {
        "title": "合同参考",
        "description": "合同参考限制可用于定义在哪些双边合同详细信息下共享数据。"
      },
      "Dismantler": {
        "title": "拆解员",
        "description": "持有该资质的企业为拆解企业。",
        "allowedBrands": {
          "title": "拆解员允许的品牌",
          "description": "定义拆解员的公司角色。持有该资质的企业为拆解企业。"
        }
      },
      "UsagePurpose": {
        "title": "使用目的",
        "description": "使用目的"
      },
      "FrameworkAgreement": {
        "title": "框架协议",
        "description": "有了框架协议凭证，只有那些签署了相应框架协议（通用或特定版本）的参与者才被允许查看或协商相应的数据要约。"
      },
      "Duration": {
        "title": "期间",
        "description": "从签署之日起的数据使用期限。"
      },
      "inForceDate": {
        "title": "固定日期范围",
        "description": "数据使用的固定日期时间范围。"
      },
      "connector": {
        "title": "连接器限制",
        "description": "持有连接器的公司因该限制而使用。"
      }
    },
    "fields": {
      "BusinessPartnerNumber": "业务合作伙伴编号",
      "tx:BusinessPartnerGroup": "业务合作伙伴组",
      "cx-policy:Membership": "会员资格",
      "cx-policy:ContractReference": "合同参考",
      "cx-policy:Dismantler.allowedBrands": "拆解员允许的品牌",
      "cx-policy:Dismantler": {},
      "cx-policy:UsagePurpose": "使用目的",
      "cx-policy:FrameworkAgreement": "框架协议",
      "duration": "期间",
      "unit": "单元",
      "fromdate": "开始日期",
      "todate": "迄今为止",
      "connector": "连接器"
    }
  },
  "jobs": {
    "jobs": "任务",
    "id": "ID",
    "name": "名称",
    "startedAt": "开始时间",
    "status": "状态",
    "duration": "持续时间",
    "action": "操作",
    "jobDetails": "处理详情",
    "reload": "重新加载",
    "noDetailsAvailable": "此任务没有更多详情",
    "retry": "重试"
  },
  "search-offer": {
    "pageTitle": "搜索数据优惠",
    "pcfTitle": "搜索 PCF 数据优惠",
    "certificateTitle": "搜索业务合作伙伴证书报价",
    "filter": {
      "bpnSearch": "通过您的业务合作伙伴编号或公司名称搜索",
      "bpnSearchNote": "通过公司名称或 BPN 查找数据优惠。",
      "manufacturePartId": "制造商零件 ID",
      "manufacturePartIdNote": "搜索与给定零件 ID 匹配的所有数据优惠。",
      "enter": "输入 {field}",
      "connectorUrl": "连接器 URL",
      "connectorUrlNote": "在特定连接器中搜索数据",
      "subModel": "子模型",
      "subModelNote": "为您的预期用例优化搜索结果",
      "search": "搜索",
      "searchBy": "搜索方式",
      "resetFilters": "重置过滤器",
      "advancedSearch": "高级搜索",
      "name": "名称",
      "dct:type": "DCT：类型",
      "assetId": "资产 ID"
    },
    "noResult": {
      "title": "无结果",
      "description": "请搜索以浏览网络中可用的数据优惠"
    },
    "helpCard": {
      "title": "它是如何工作的？",
      "description": "发现其他数据空间参与者的数据优惠目录。您可以搜索、选择和订阅数据空间中可用的数据优惠。",
      "subtitle": "想了解更多关于数据优惠协商和消费如何运作的信息？",
      "documentation": "文档"
    },
    "offers": {
      "downloadSelected": "下载所选",
      "transferSelected": "传输所选",
      "negotiate": "协商",
      "noOffer": "没有可用的数据优惠。"
    },
    "offer-details": {
      "title": "确认合同协商",
      "description": "描述",
      "details": "详情",
      "attachedPolicies": "附加政策",
      "termsCheck": "我同意合同条款，并希望开始合同协商和数据交换。",
      "negotiate": "协商",
      "negotiateAndDownload": "协商并下载",
      "negotiateAndTransfer": "协商并传输",
      "transfer": "传输",
      "cancel": "取消",
      "attribute": "属性",
      "value": "值",
      "endpointUrl": "端点 URL",
      "organization": "组织",
      "bpnNumber": "BPN 编号",
      "manufacturerPartId": "制造商零件 ID",
      "noOfAssets": "所选资产数量",
      "membership": "成员资格",
      "dismantlerBrands": "允许的拆解品牌",
      "frameworkAgreement": "框架协议",
      "dismantler": "拆解者",
      "backToAssets": "返回资产",
      "noPolicyMatchTitle": "资产未协商或政策不一致",
      "noPolicyMatchText": "您尝试下载的某些资产尚未协商。或者，您尝试协商的某些资产的政策不一致。请选择正确的资产并继续。",
      "negotiateInProgress": "协商和下载正在进行",
      "negotiateAndDownloadSuccess": "协商和下载成功完成",
      "negotiateAndTransferSuccess": "协商和传输成功完成",
      "transferSuccess": "传输成功完成",
      "progress": "进度",
      "fetchShell": "获取外壳",
      "exportToCSV": "导出到 CSV",
      "fetchJobFailed": "获取任务详情时出错",
      "negotiateError": "下载资产时出错",
      "dtr": "数字孪生注册表",
      "edc": "连接器资产",
      "browseDtr": "浏览 DTR"
    },
    "dtr": {
      "title": "数字孪生外壳",
      "shells": "浏览外壳",
      "description": "您将自动协商从所选提供者的数字孪生注册表中获取和导出外壳"
    }
  },
  "assetUploadHistory": {
    "title": "资产上传历史",
    "subtitle": "此历史记录概述了您公司在数据空间连接器上的交易。所有关于资产、政策和合同定义的活动都列在此处。",
    "refresh": "刷新",
    "processId": "进程 ID",
    "providerUrl": "提供者 URL",
    "createdOn": "创建时间",
    "totalItems": "总项目",
    "successful": "成功",
    "failed": "失败",
    "startDate": "开始日期",
    "endDate": "结束日期",
    "status": "状态",
    "actions": "操作",
    "howItWork": {
      "title": "它是如何工作的？",
      "description": "您可以找到跨不同数据空间的所有上传资产历史记录。您可以在本地重新下载文件或将它们传输到外部位置。如有错误，您必须重试下载或重新协商数据优惠。",
      "moreInfo": "想了解更多关于上传历史及您可以在这里做什么？"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "历史记录为您提供了组织从数据空间协商合同中下载的数据概览。如有需要，您可以从此历史列表中再次下载数据。",
    "howItWorks": {
      "description": "您可以找到跨不同数据空间的所有下载资产历史记录。您可以在本地重新下载文件或将它们传输到外部位置。如有错误，您必须重试下载或重新协商数据优惠。",
      "moreInfo": "想了解更多关于下载历史及您可以在这里做什么？"
    },
    "downloadError": "下载不成功，请重试！",
    "viewErrors": "查看错误"
  },
  "digitalTwinBrowser": {
    "subHeading": "这些是您的数字孪生及其子模型。您的数字孪生通过您的数字孪生注册表暴露给数据空间。",
    "noDocumentError": "当前 ID 没有 aspectDocument",
    "nameNotProvided": "未提供名称",
    "fetchDigitalTwinsError": "无法获取数字孪生",
    "fetchAspectDocumentError": "无法获取方面文档",
    "fetchAspectModelError": "无法获取方面模型",
    "detailsOverviewModalTitle": "方面详情",
    "addItem": "添加项目",
    "detailsTable": {
      "id": "ID",
      "idShort": "短 ID",
      "displayName": "显示名称",
      "modelUrn": "模型 URN"
    },
    "shellsTable": {
      "id": "ID",
      "name": "名称",
      "manufacturer": "制造商零件 ID",
      "modifiedBy": "用户",
      "modifiedAt": "时间"
    }
  },
  "connector": {
    "addNewConnector": "+ 添加新连接器",
    "searchConnector": "按连接器名称搜索",
    "connectorModal": {
      "error": "获取连接器详细信息失败"
    }
  },
  "column": {
    "name": "名称",
    "connectorName": "连接器名称",
    "contractId": "合同 ID",
    "productId": "产品 ID",
    "manufacturerPartId": "制造商零件 ID",
    "manufacturerId": "制造商 ID",
    "digitalTwinType": "数字孪生类型",
    "correlationId": "关联 ID",
    "requestId": "请求 ID",
    "bpn": "巴布亚新几内亚",
    "createdAt": "创建时间",
    "createdBy": "创建者",
    "attribute": "属性",
    "url": "网址",
    "actions": "操作",
    "lastUpdatedTime": "最后更新时间",
    "status": "状态",
    "requestedDate": "请求日期",
    "policyType": "政策类型",
    "modifiedBy": "修改者",
    "modifiedOn": "修改时间",
    "syncStatus": "同步状态",
    "assetId": "资产 ID",
    "assetType": "资产类型",
    "type": "类型",
    "createdFrom": "创建起始时间",
    "createdTo": "创建结束时间",
    "statusDuration": "状态/持续时间",
    "certifier": "验证者",
    "version": "版本",
    "registrationNumber": "注册号",
    "validUntil": "有效期截止",
    "offerId": "产品/服务 ID",
    "errorMessage": "错误信息",
    "globalAssetId": "全局资产ID",
    "shellName": "Shell名称",
    "contractAgreementId": "合同协议 ID",
    "signingDate": "签署日期",
    "providerConnectorUrl": "提供商连接器URL",
    "consumerConnectorUrl": "消费者连接器URL",
    "providerBpnl": "提供商BPNL",
    "consumerBpnl": "消费者BPNL",
    "counterPartyId": "对方 ID",
    "resourceId": "资源 ID",
    "resourceType": "资源类型",
    "transactionMethod": "交易方法",
    "trustLevel": "信任级别",
    "partId": "零件编号"
  },
  "messagesBrowser": {
    "fetchMessagesError": "无法获取消息",
    "openRelatedMessage": "打开相关消息",
    "messagesTable": {
      "id": "ID",
      "name": "名称",
      "createdAt": "创建时间",
      "createdBy": "创建者",
      "type": "类型",
      "context": "上下文",
      "senderBpn": "发送者 BPN",
      "receiverBpn": "接收者 BPN",
      "correlationId": "关联 ID",
      "jobId": "任务 ID",
      "conversationId": "对话 ID",
      "status": "状态"
    },
    "messageType": {
      "ecu": "电子控制单元",
      "generic": "通用",
      "quality": "质量",
      "ccmpush": "CCM 推送",
      "ccmrequest": "CCM 请求",
      "ccmstatus": "CCM 状态",
      "ccmavailable": "CCM 可用",
      "blockNotification": "阻止通知",
      "dtrEvent": "DTR事件"
    }
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "基本证书信息",
        "issuer": "发行人信息",
        "validity": "有效期",
        "trust": "信任信息",
        "validator": "验证器信息",
        "application": "应用区",
        "enclosedSites": "封闭地点"
      },
      "fields": {
        "businessPartnerNumber": "业务伙伴编号",
        "registrationNumber": "注册号",
        "certificateType": "证书类型",
        "certificateVersion": "证书版本",
        "issuerName": "发行人名称",
        "issuerBpn": "发行人BPN",
        "validFrom": "有效",
        "validUntil": "有效直到为止",
        "trustLevel": "信任水平",
        "uploaderBpn": "上传器BPN",
        "validatorBpn": "验证器BPN",
        "validatorName": "验证器名称",
        "areaOfApplication": "申请区域",
        "siteBpn": "网站BPN",
        "siteAreaOfApplication": "申请现场区域"
      },
      "tooltips": {
        "basicInfo": "业务伙伴证书描述了证书（例如ISO9001，IATF-16949）",
        "businessPartnerNumber": "认证法律实体的业务伙伴编号（BPN）（签发证书）。",
        "registrationNumber": "证书中定义的证书的注册号",
        "certificateType": "文档中定义的证书类型，有效类型已在BPN元数据托管中注册",
        "certificateVersion": "文档中定义的证书的版本通常是认证标准的特定版本",
        "issuerName": "发行人的名称，即认证机构。",
        "issuerBpn": "发行人的业务伙伴编号（BPN）。",
        "validFrom": "从证书上定义的日期为有效。",
        "validUntil": "有效，直到证书上的定义为止。",
        "trustLevel": "给定证书的信任水平 - 无，低，高，值得信赖",
        "uploaderBpn": "业务伙伴的业务伙伴编号（BPN）最初提供了证明数据或文件。",
        "validatorBpn": "验证给定证书的数据服务提供商的业务伙伴号（BPN）",
        "validatorName": "验证给定证书的数据服务提供商的可选名称",
        "areaOfApplication": "详细信息，有关公司和 /或网站有效的哪些领域 /应用程序类型。",
        "siteBpn": "封闭网站的业务伙伴编号（BPN或BPNA）",
        "siteAreaOfApplication": "详细信息，有关公司和 /或网站有效的哪些领域 /应用程序类型。"
      }
    }
  },
  "bpnSelector": {
    "selectFromList": "从列表中选择",
    "enterManually": "手动输入",
    "selectPlaceholder": "选择位置 BPN",
    "manualPlaceholder": "输入 BPN（例如 BPNL123456789ABC）",
    "validFormat": "有效的 BPN 格式",
    "invalidFormat": "BPN 格式无效",
    "invalidFormatHint": "格式：BPNL + 12 个字母数字字符",
    "formatHint": "格式：BPNL123456789ABC（共16个字符）",
    "selected": "已选择"
  },
  "searchableSelect": {
    "pressEnterToUse": "按 Enter 键以使用此 BPNA/BPNS",
    "placeholderText": "请输入有效的 BPNA/BPNS",
    "placeholder": "选择或输入 BPNA/BPNS"
  },
  "blockNotifications": {
    "title": "阻止通知",
    "description": "欢迎使用 Catena-X 中易于使用的端到端业务合作伙伴证书管理交换解决方案。",
    "recentNotifications": "最近的通知",
    "totalAffected": "受影响部位总数",
    "top5": "前 5 名交易所合作伙伴",
    "sendNotifications": "发送通知",
    "sendUpdate": "发送更新",
    "sentHistory": "发送通知历史记录",
    "receivedHistory": "收到的通知历史记录",
    "sendDescription": "在 Catena-X 网络中创建并共享您的站点证书",
    "learnMore": "了解有关阻止通知的更多信息",
    "filters": {
      "lastYear": "过去 1 年",
      "sixMonths": "6个月",
      "threeMonths": "3个月",
      "oneMonth": "1个月",
      "lastWeek": "上星期",
      "selectDateRange": "选择日期范围",
      "bpnOrCompany": "业务伙伴编号或公司名称"
    },
    "stats": {
      "totalAffectedParts": "受影响部位总数",
      "topExchangePartners": "前 {count} 个 Exchange 合作伙伴",
      "sentNotifications": "已发送通知",
      "receivedNotifications": "收到通知"
    },
    "sentHistoryDescription": "使用该区域来管理来自合作伙伴的证书数据请求。",
    "receivedHistoryDescription": "查看和管理从合作伙伴收到的阻止通知。",
    "table": {
      "name": "姓名",
      "conversationName": "对话名称",
      "problemId": "问题ID",
      "partner": "伙伴",
      "bpn": "BPN 号码",
      "createdAt": "创建于",
      "createdBy": "创建者：",
      "modifiedAt": "修改于",
      "modifiedBy": "修改者",
      "status": "地位",
      "partnerName": "合作伙伴名称",
      "sentBy": "发送者",
      "sentOn": "发送于",
      "receivedOn": "收到于"
    },
    "errors": {
      "fetchSentNotifications": "无法获取已发送的通知",
      "fetchStatistics": "无法加载通知统计信息",
      "fetchRecentNotifications": "无法加载最近的通知",
      "invalidDateRange": "无法获取没有有效日期范围的统计信息",
      "sendNotificationFailed": "发送阻止通知失败。",
      "validationFailed": "请填写所有必填字段："
    },
    "confirmationText": "我了解并确认我已正确填写所有必填信息。",
    "validityDisclaimer": "T-Systems 不会检查此处填写的元数据信息的有效性。",
    "generalInformation": "一般信息",
    "jobName": "职位名称",
    "jobNamePlaceholder": "输入职位名称",
    "receiverBpn": "接收器BPN",
    "expectedResponseBy": "预期回应",
    "success": {
      "notificationSent": "阻止通知发送成功",
      "notificationUpdateSent": "阻止通知更新发送成功"
    },
    "groups": {
      "notificationInformation": "通知信息",
      "blockInformationItems": "块信息项 *",
      "partIdentification": "零件识别",
      "componentLevelContainment": "组件级遏制",
      "periodAndVolumeLevelContainment": "周期和音量级别控制",
      "deliveryInformation": "配送信息",
      "quantities": "数量",
      "sizeOfProductionLot": "生产批量大小",
      "numberOfPartsPerDeliveryNote": "每份交货单的零件数量",
      "numberOfPartsPerPackage": "每包零件数量",
      "locationInContainer": "容器中的位置（可选）"
    },
    "fields": {
      "problemId": "问题ID",
      "notificationStatus": "通知状态",
      "problemDescription": "问题描述",
      "updateReason": "更新原因",
      "catenaXId": "Catena-X ID",
      "blockStatus": "区块状态",
      "manufacturingLocationId": "制造地点 ID",
      "customerPartId": "客户零件 ID",
      "integrationLevel": "集成度",
      "localIdentifiers": "本地标识符",
      "key": "钥匙",
      "value": "价值",
      "orderNumber": "订单号",
      "deliveryNoteNumber": "交货单编号",
      "packageNumber": "包裹数量",
      "deliveryPlace": "交货地点",
      "productionDate": "生产日期",
      "deliveryDate": "交货日期",
      "quantity": "数量",
      "unit": "单元",
      "xPosition": "X 位置",
      "yPosition": "Y 轴位置",
      "smallLoadCarrierLayer": "小承载层"
    },
    "editNotification": "编辑通知",
    "importJson": {
      "title": "导入 JSON 文件",
      "description": "上传 JSON 文件以使用提供的数据自动填充表单。",
      "importButton": "从 JSON 导入",
      "dropFileHere": "将 JSON 文件拖放到此处",
      "selectFile": "选择文件",
      "import": "进口",
      "success": "已成功从 JSON 导入表单数据",
      "parseError": "解析 JSON 文件失败",
      "readError": "读取文件失败。"
    },
    "tooltips": {
      "problemDescription": "自由文本字段，提供必须阻止部件的信息。",
      "updateReason": "自由文本，描述为什么需要更新先前提供的损坏零件列表。",
      "catenaXId": "序列化零件或批次的完全匿名 Catena-X ID。",
      "blockStatus": "阻止通知中各个部分的状态。",
      "manufacturingLocationId": "组件交付的供应商地点的地址。"
    },
    "updateNotification": "更新通知",
    "notificationDetails": "通知详情",
    "howTo": {
      "description": "快速行动，快速轻松地向 Catena-X 网络内的合作伙伴发送有关缺陷零件的阻止通知。",
      "doc": "想了解更多有关阻止通知如何工作的信息吗？"
    }
  }
}
